import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {priceWithIVA} from '../../../utils/priceWithIVA';
import {RmOrderService} from '../../services/rm-order.service';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {orderType} from '../../../shared/constantes';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-rate-info',
    templateUrl: './rm-rate-info.component.html',
    styleUrls: ['./rm-rate-info.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmRateInfoComponent implements OnInit, OnDestroy {
    @Input() rate: any = null;
    @Input() subrate: any = null;
    public typeOrder = null;
    public ratesDescriptions = [];
    private allSubscription: Subscription[] = [];

    constructor(
        public activeModal: NgbActiveModal, 
        public rmService: RepublicaMovilService
    ) { }

    ngOnInit(): void {
        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data) => {
                this.typeOrder = data;
            })
        );

        this.getDescriptionSections();
    }

    totalRate() {
        let total = this.rate.rateAmount;
        if (this.subrate !== null) {
            total += this.subrate.rateAmount;
        }
        return priceWithIVA(total).toFixed(0);
    }

    getDescriptionSections() {
        const rateSections: any = [];

        let currItem = new Map();
        for (const info of this.rate.infoDetails) {
            if (this.typeOrder === orderType.BROADBAND && info.title !== 'Fibra') {
                continue;
            }
            if (!currItem.has(info.title)) {
                // currItem[info.title] = [];
                currItem.set(info.title, []);
            }
            currItem.get(info.title).push(info.description);
        }
        rateSections.push(currItem);
        currItem = new Map();
        if (this.subrate !== null) {
            for (const info of this.subrate.infoDetails) {
                if (!currItem.has(info.title)) {
                    currItem.set(info.title, []);
                }
                currItem.get(info.title).push(info.description);
            }
            rateSections.push(currItem);
        }
        this.ratesDescriptions = rateSections;
        console.log(this.ratesDescriptions);
    }

    asIsOrder(a, b) {
        return 1;
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
